/**
 * Interview Calendar
 *
 * @param $scope
 * @param options {}
 *
 * @constructor
 */
window.InterviewCalendar = function (Nunjucks, options) {
    var self = this;

    var element;
    var validSlotClass = 'hCalendar-valid-slot';

    var TEMPLATES = {
        CALENDAR: '../modules/interview-calendar/views/calendar_main.html',
        HEADER: '../modules/interview-calendar/views/partials/calendar_head.html',
        BODY: '../modules/interview-calendar/views/partials/calendar_body.html',
        SLOT_CONTENT: '../modules/interview-calendar/views/partials/calendar_slot_content.html',
    };

    var precompiled;

    var interviewWeekRange = 6;
    var HOUR_MINUTE = 60;
    var VISIBLE_CANDIDATES_IN_SLOT = 3;

    var lastSlotWithMiniTime = null;

    var DEFAULT_OPTS = {
        type: 'schedule',
        startDate: moment().set('hour', InterviewCalendar.hourStart),
        elementSelector: '#candidate-interview-calendar',
        hoursRange: 24,
        slotParts: 2,
        minNavDateTime: moment().set('hour', InterviewCalendar.hourStart),
        maxNavDateTime: moment().set('hour', InterviewCalendar.hourStart).add(interviewWeekRange, 'weeks'),
        selectionType: 'click',
        employerSlots: [],
        clearNotNeededRows: false,
        applyCustomScroller: false,
        enableSlotsTooltip: false
    };

    options = options || {};

    options = $.extend(DEFAULT_OPTS, options);

    /***
     *
     * Bind Sele
     */
    var bindSelectableAction = function (selector) {

        selector = selector || ".slot";

        var isMouseDown = false;
        var isHighlighted = false;

        var mouseMoveHandler = function(){

            if (isMouseDown) {

                var elementInTarget = $(this).parents("[data-cells='" + (4/options.slotParts) + "']");

                if (elementInTarget.hasClass("expired") || elementInTarget.find(".expired").length) {
                    return;
                }

                // Change the slot based on first cell selected state
                if (isHighlighted && elementInTarget.hasClass(InterviewCalendar.selectedClass)) {
                    onSlotChanged(elementInTarget);
                } else if (!isHighlighted && !elementInTarget.hasClass(InterviewCalendar.selectedClass)) {
                    onSlotChanged(elementInTarget);
                }
            }
        };

        element.find(selector).off(".mousedownSelectable").on("mousedown.mousedownSelectable", function(){

            var elementInTarget = $(this).parents("[data-cells='" + (4/options.slotParts) + "']");

            if (elementInTarget.hasClass("expired") || elementInTarget.find(".expired").length) {
                return;
            }

            isMouseDown = true;


            if (options.type == 'schedule') {
                element.find(".slot").off(".mousemoveSelectable").on("mousemove.mousemoveSelectable", mouseMoveHandler);
            }

            //save state of the first cell selected
            isHighlighted = elementInTarget.hasClass(InterviewCalendar.selectedClass);
            onSlotChanged(elementInTarget);

            return false;
        });


        $(document).off(".mouseupSelectable").on("mouseup.mouseupSelectable", function() {
            element.find(".slot").off(".mousemoveSelectable");
            isMouseDown = false;
        });
    };
    /****
     * Bind Click Action on calendar slots
     */
    var bindClickAction = function () {
        $(document).off('click', '.interview-calendar .valid .slot');
        $(document).on('click', '.interview-calendar .valid .slot', function () {

            var elementInTarget = $(this).parents("[data-cells='" + (4/options.slotParts) + "']");

            if (elementInTarget.hasClass("expired") || elementInTarget.find(".expired").length) {
                return;
            }

            onSlotChanged(elementInTarget);
        });
    }


    /*
     * on slot clicked, changed , selected
     */
    var onSlotChanged = function (slotElement) {
        var startDate = getSlotTime(options.startDate, slotElement);
        var endDate = startDate + (slotElement.data("cells") * 15 * 60 * 1000);

        var slot = {
            id: slotElement.data("id") || startDate,
            start_time: startDate,
            end_time: endDate
        };

        if (options.type == 'schedule') {
            slotElement.find("." + InterviewCalendar.selectedClass).removeClass(InterviewCalendar.selectedClass);
            slotElement.toggleClass(InterviewCalendar.selectedClass);
        }
        else {
            element.find("." + InterviewCalendar.selectedClass).removeClass(InterviewCalendar.selectedClass);
            slotElement.addClass(InterviewCalendar.selectedClass);
        }

        slot.selected = slotElement.hasClass(InterviewCalendar.selectedClass);

        var slotElementId = slot.selected? slot.id: "";
        slotElement.data("id", slotElementId);

        if (options.onSlotChanged) {
            options.onSlotChanged(slot);
        }
    }

    /*
     * Prev clicked - calendar navigation
     */
    var onPrevClick = function () {
        self.renderCalendar(options.startDate.subtract(7, 'days'));
        if (options.onPrevClick) options.onPrevClick();
    };


    /**
     *
     * Next clicked - calendar navigation
     */
    var onNextClick = function () {
        self.renderCalendar(options.startDate.add(7, 'days'));
        if (options.onNextClick) options.onNextClick();
    };

    var clearNotNeededRows = function () {
        element.find('tbody tr:not(:has(.' + validSlotClass + '))').hide();
    }

    /*
     Build Calendar Data
     */
    var buildCalendar = function (date) {

        var _date = date.clone();

        var calendar = {
            // Header initial data (data skeleton)
            header: {
                head: {
                    data: ''
                },
                cells: []
            },

            // Body initial data (data skeleton)
            body: {
                rows: []
            }
        };

        // Build Days names header for Calendar (7 for a week)
        // Days (Head of columns)
        for (var i = 0; i < 7; i++) {
            calendar.header.cells.push({
                data: _date.format("ddd MM/DD")
            });

            _date = _date.clone();
            _date.add(1, "d");
        }


        _date = date.clone();
        var startHour = _date.hours();

        // Builder the Calendar body
        for (var hourCount = 0; hourCount < options.hoursRange; hourCount++) {

            // Add 1 hour
            _date.hours((startHour + hourCount));

            var dateObj = {
                // Hours (Head of row)
                head: _date.format('h:mm a'),
                cells: []
            };

            for (var dayCount = 0; dayCount < 7; dayCount++) {
                // Push to row
                dateObj.cells.push({});
            }

            calendar.body.rows.push(dateObj);
        }

        return calendar;
    };

    var getSlot = function(startDate, endDate) {
        // This is to fix timezone differs from day to day (due to daylight saving)
        var timezoneOffset = moment(startDate).zone() - moment(options.startDate).zone();
        var slotOffset = (startDate - options.startDate) / (60 * 1000); // In minutes
        var daysOffset = parseInt(slotOffset / (24 * 60));

        var slotDuration = (endDate - startDate) / (1000 * 60); // Duration in minutes
        var slotParts = 4 / (HOUR_MINUTE / slotDuration);

        var minutesOffset = parseInt((slotOffset % 60) / slotDuration);
        var hoursOffset = parseInt(((slotOffset - timezoneOffset) % (24 * 60)) / 60);

        var selector = ".calendar-row[data-index='" + hoursOffset + "'] .slots-group[data-cells='4'][data-index='" + daysOffset + "']";

        if (slotParts != 4) {
            selector = selector + " .slots-group[data-cells='" + slotParts + "'][data-index='" + minutesOffset + "']";
        }

        return element.find(selector);
    };

    var resetView = function() {
        if (element) {
            element.find(".selected").removeClass("selected");
            element.find(".valid").removeClass("valid");
            element.find(".has-interviews").removeClass("has-interviews");
            element.find(".slots-group").data("id", "");
            element.find(".slots-group .content").remove();
        }
    };

    /****
     *
     * add slots from BE
     *
     * @param slots
     */
    function addSlotsPart(slots) {

        resetView();

        if (!slots || !slots.length) {
            return;
        }

        slots.forEach(function (slotData) {

            // Make sure that time is in minutes
            slotData.start_time.setSeconds(0);
            slotData.start_time.setMilliseconds(0);
            // Make sure that time is in minutes
            slotData.end_time.setSeconds(0);
            slotData.end_time.setMilliseconds(0);

            var slotEl = getSlot(slotData.start_time, slotData.end_time);

            if (!slotEl.length) {
                // Slot is not within rendered area
                return;
            }

            slotData.saved = true;

            //find match in DB and it's confirm
            if (options.type == 'confirm') {
                slotData.validSlotPart = true;
                slotEl.addClass("valid");
            }

            if (options.type == 'schedule') {
                slotData.selectedSlotPart = true;
                slotData.validSlotPart = !slotEl.hasClass("expired");
                slotEl.addClass(InterviewCalendar.selectedClass);
            }

            slotEl.data("id", slotData.id);

            slotData.index = slotEl.data('index');

            if (slotData.reserved_by && slotData.reserved_by.length > 0) {
                if (slotData.reserved_by.length > VISIBLE_CANDIDATES_IN_SLOT) {
                    slotData.other_reserved_by = '';
                    for (var j = VISIBLE_CANDIDATES_IN_SLOT - 1; j < slotData.reserved_by.length; j++) {
                        slotData.other_reserved_by += slotData.reserved_by[j].first_name + ' ' + slotData.reserved_by[j].last_name + '<br>';
                    }
                    slotData.reserved_by = slotData.reserved_by.slice(0, VISIBLE_CANDIDATES_IN_SLOT - 1);
                }

                var contentHTML = Nunjucks.render(TEMPLATES.SLOT_CONTENT, {part: slotData});
                slotEl.addClass("has-interviews");
                slotEl.append(contentHTML);

                slotEl.find('.content span').tooltip({
                    container: 'body',
                    placement: function (tip, tooltipElement) {
                        var position = $(tooltipElement).parent().parent().position();

                        var containerWidth = element.width();

                        var margin = 100;

                        if (position.left < (containerWidth - margin)) {
                            return "top";
                        }

                        return "left";
                    }
                });
            }

        });

        // Assign listeners to slot content elements (interview candidates)
        bindSelectableAction(".content");
    }


    /****
     *
     * get slot with lowest startTime
     *
     * @param slots
     */
    function getSlotWithLowestSTime(slots,startDate,endDate) {

        startDate = startDate.clone();
        endDate = endDate.clone();

        // Make sure that time is in minutes
        startDate.second(0);
        startDate.millisecond(0);
        startDate.hour(0);
        startDate.minute(0);
        // Make sure that time is in minutes
        endDate.second(0);
        endDate.millisecond(0);
        endDate.hour(0);
        endDate.minute(0);

        if (!slots || !slots.length) {
            return;
        }

        var slotWithLowestSTime = null;
        slots.forEach(function (slotData) {

            if(startDate.valueOf() <=  slotData.start_time.getTime() &&  slotData.start_time.getTime()< endDate.valueOf()){
                if(!slotWithLowestSTime || (slotData.start_time.getHours() < slotWithLowestSTime.start_time.getHours())){
                    slotWithLowestSTime = slotData;
                }
            }

        });
        return slotWithLowestSTime;
    }


    /***
     * update calendar offset
     *
     * @param offset
     */
    self.updateCalendarOffset = function(offset){
        setTimeout(function(){
            offset = offset || lastSlotWithMiniTime.position().top-66;
            element.find('.interview-calendar').mCustomScrollbar("scrollTo",offset);
        },200);
    }


    /*
     Render Calendar
     */
    self.renderCalendar = function (startDate) {

        startDate = startDate || options.startDate;

        // Make sure that the start date of the calendar starts from the beginning of the hour
        startDate.set('minutes', 0);

        var calendarData = buildCalendar(startDate);
        var prevNav = startDate.isAfter(options.minNavDateTime);
        var nextNav = startDate.isBefore(options.maxNavDateTime.clone().subtract(6, 'days'));

        var headerTitle = '';
        var startDateTitle = startDate.clone();
        var endDateTitle = startDate.clone().add(6, 'days');
        //same month
        if(startDateTitle.format("MMMM") == endDateTitle.format("MMMM"))
        {
            headerTitle = startDateTitle.format("MMMM") + ' ' + startDateTitle.format('D') + '-' + endDateTitle.format('D') + ' ' + startDateTitle.format('YYYY');
        }
        //different month but same year
        else if(startDateTitle.format("YYYY") == endDateTitle.format("YYYY")){
            headerTitle = startDateTitle.format("MMMM") + ' ' + startDateTitle.format('D') + ' - ' + endDateTitle.format("MMMM") + ' ' + endDateTitle.format('D') + ' ' + startDateTitle.format('YYYY');
        }
        //different month different year
        else{
            headerTitle = startDateTitle.format("MMMM") + ' ' + startDateTitle.format('D') + ' ' + startDateTitle.format('YYYY')+ ' - ' + endDateTitle.format("MMMM") + ' ' + endDateTitle.format('D') + ' ' + endDateTitle.format('YYYY');
        }

        var headerData = {
            header: calendarData.header,
            title: headerTitle
        };

        resetView();

        var headerHTML = Nunjucks.render(TEMPLATES.HEADER, headerData);

        renderCalendar(calendarData, function() {

            element.attr("data-duration", options.slotParts);

            var header = $(headerHTML);
            var prevButton = header.find(".prev");
            var nextButton = header.find(".next");

            if (!prevNav) {
                prevButton.hide();
            }
            else {
                prevButton.on('click', onPrevClick);
            }

            if (!nextNav) {
                nextButton.hide();
            }
            else {
                nextButton.on('click', onNextClick);
            }

            element.find(".calendar-head").html(header);
            refreshExpiredSlots(startDate);

            //add slots from BE
            addSlotsPart(options.employerSlots);
            if (options.clearNotNeededRows) {
                clearNotNeededRows();
            }

            // Bind selection type
            if (options.selectionType == 'selectable') {
                bindSelectableAction();
            } else {
                bindClickAction();
            }

            //add slots tooltip
            if(options.enableSlotsTooltip){
                slotsTooltip();
            }


            //add scroll styling
            if(options.applyCustomScroller){
                //if it's only confirm then get slot with lowest start time
                if (options.type == 'confirm') {
                    //define date range to find slot with lowest start time usually it's the start date +7 days
                    var endDate = startDate.clone();
                    endDate.add(7, 'days');
                    //get slot data
                    var lSlot = getSlotWithLowestSTime(options.employerSlots,startDate,endDate);
                    //get slot el
                    var _eSlot = getSlot(lSlot.start_time,lSlot.end_time);
                    if(!_eSlot.hasClass('cell')){
                        _eSlot = _eSlot.closest('.cell');
                    }
                    //send top offset of the slot to custom scroller
                    //66 is calendar header height
                    lastSlotWithMiniTime = _eSlot;
                    applyCustomScroller(lastSlotWithMiniTime.position().top-66);
                }

                if (options.type == 'schedule') {
                    //eight row
                    var _eightRow = element.find('.calendar-row').eq(8);
                    applyCustomScroller(_eightRow.position().top-66);
                }
            }

        });

    };

    var refreshExpiredSlots = function(date) {

        if (options.enableMinMaxLimits) {
            var slots = element.find(".slot").toArray();

            for (var i in slots) {
                if (getSlotTime(date, $(slots[i]).parent()) < Date.now() || getSlotTime(date, $(slots[i]).parent()) <  options.minNavDateTime.valueOf() || getSlotTime(date, $(slots[i]).parent()) > options.maxNavDateTime.valueOf()) {
                    $(slots[i]).parent().addClass("expired");
                }
                else {
                    $(slots[i]).parent().removeClass("expired");
                }
            }

        } else {
            if (date.isAfter(Date.now())) {
                element.find(".expired").removeClass("expired");
            }
            else {
                var slots = element.find(".slot").toArray();

                for (var i in slots) {
                    if (getSlotTime(date, $(slots[i]).parent()) < Date.now()) {
                        $(slots[i]).parent().addClass("expired");
                    }
                    else {
                        $(slots[i]).parent().removeClass("expired");
                    }
                }
            }
        }
    };

    var getSlotTime = function(offsetDate, $slotsGroup) {
        var isCompleteCell = false;

        var $cell = $slotsGroup.parents(".cell");

        if ($slotsGroup.hasClass("cell")) {
            isCompleteCell = true;
            $cell = $slotsGroup;
        }

        var $row = $cell.parents(".calendar-row");
        var slotDuration = (60 / (4 / $slotsGroup.data("cells")));

        slotTime = offsetDate;

        if (!isCompleteCell) {
            slotTime += (slotDuration * 60 * 1000 * $slotsGroup.data("index"));
        }

        slotTime += 24 * 60 * 60 * 1000 * $cell.data("index");
        slotTime += 60 * 60 * 1000 * $row.data("index");

        // To fix issue when timezone differs from day to day (when daylight saving)
        var timezoneOffset = offsetDate.zone() - moment(slotTime).zone();
        slotTime -= (timezoneOffset * 60 * 1000);

        return slotTime;
    }

    /*****
     *
     * Add tooltip to slots
     *
     *
     */

    var slotsTooltip = function(){

        element.find('.interview-calendar .valid .slot').off(".mouseenterTooltip").on("mouseenter.mouseenterTooltip", function(){
            var elementInTarget = $(this).parents("[data-cells='" + (4/options.slotParts) + "']");
            var startTime = getSlotTime(options.startDate,elementInTarget);
            var endTime = startTime + (60/options.slotParts)*60000;
            startTime = moment(startTime);
            endTime = moment(endTime);

            // Hover over code
            var title = $(this).attr('title');
            if(!title){
                title = startTime.format("h:mm")+' '+startTime.format('a')+' - '+endTime.format("h:mm")+' '+endTime.format('a');
            }
            $(this).data('tooltip-text', title).removeAttr('title');
            $('<p class="interview-tooltip"></p>')
                .text(title)
                .appendTo('body')
                .fadeIn('slow');
        });

        element.find('.slot').off(".mouseleaveTooltip").on("mouseleave.mouseleaveTooltip", function(){
            // Hover out code
            $(this).attr('title', $(this).data('tooltip-text'));
            $('.interview-tooltip').remove();
        });

        element.find('.slot').off(".mousemoveTooltip").on("mousemove.mousemoveTooltip", function(e){
            var mousex = e.pageX + 20; //Get X coordinates
            var mousey = e.pageY + 10; //Get Y coordinates
            $('.interview-tooltip').css({ top: mousey, left: mousex });
        });
    }
    /***
     *
     * Render Calendar not be called by outsiders
     */
    var renderCalendar = function (data, callback) {

        var calendarRenderData = {
            body: data.body,
            header: data.header,
            type: options.type
        };

        element = $(options.elementSelector);

        if (precompiled) {
            if (callback) callback();
        }
        else {

            element.html("");

            Nunjucks.render(TEMPLATES.CALENDAR, calendarRenderData, function (err, html) {

                if (err) {
                    console.error(err);
                }

                precompiled = true;

                // Append new calendar just created
                element.html(html);

                if (callback) callback();
            });
        }

    };

    /* adding the custom scroller */
    var applyCustomScroller = function(topOffset){
        topOffset = topOffset || 800;

        element.find('.interview-calendar').mCustomScrollbar({
            callbacks: {
                whileScrolling: function() {
                    element.find('.calendar-head').css("top", -1 * this.mcs.top);
                }
            },
            setTop: topOffset+"px",
            scrollInertia: 60,
            theme: "dark-3"
        });
    }

    /*
     * Validate Calendar
     */

    self.isValid = function () {
        return element.find('.interview-calendar .slots-group.' + InterviewCalendar.selectedClass + ':not(.expired)').length;
    }


    /*
     * init calendar
     */

    var init = function () {
        //render calendar on init
        self.renderCalendar(options.startDate);
    }

    init();

};


InterviewCalendar.selectedClass = 'selected';
InterviewCalendar.hourStart = 0;
InterviewCalendar.interviewWeekRange = 6;
